import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Text,
  VStack,
} from "@chakra-ui/react";
import ContentsList from "./ContentsList";

const advertiserLabel = (item) =>
  item?.advertiserName ||
  (item?.advertiserProfileId
    ? `광고주 #${item.advertiserProfileId}`
    : "광고주 미지정");

const groupByAdvertiser = (items) => {
  const groups = new Map();
  (items ?? [])
    .filter(
      (item) => Array.isArray(item.creatorCards) && item.creatorCards.length > 0
    )
    .forEach((item) => {
      const key = item.advertiserProfileId ?? "unknown";
      if (!groups.has(key)) {
        groups.set(key, {
          key,
          advertiserName: advertiserLabel(item),
          campaigns: [],
        });
      }
      groups.get(key).campaigns.push(item);
    });
  return Array.from(groups.values());
};

export default function GroupedContentsTab({ list }) {
  const groups = groupByAdvertiser(list);

  if (groups.length === 0) {
    return (
      <Text fontSize="14px" color="gray.500">
        검색 결과가 없습니다.
      </Text>
    );
  }

  return (
    <Accordion allowMultiple defaultIndex={groups.map((_, index) => index)}>
      {groups.map((group) => (
        <AccordionItem
          key={group.key}
          border="1px solid #E2E8F0"
          borderRadius="10px"
          mb="12px"
          overflow="hidden"
          bg="white"
        >
          <AccordionButton px="16px" py="12px" _expanded={{ bg: "#F5F9FF" }}>
            <Box flex="1" textAlign="left">
              <Text fontSize="16px" fontWeight="700" color="#172940">
                {group.advertiserName}
              </Text>
              <Text fontSize="13px" color="#5D6979">
                캠페인 {group.campaigns.length}개
              </Text>
            </Box>
            <AccordionIcon color="#0054C0" />
          </AccordionButton>
          <AccordionPanel bg="#FAFCFF" px="16px" py="12px">
            <VStack spacing="8px" w="100%" align="stretch">
              {group.campaigns.map((item) => (
                <Box w="100%" key={item.campaignId}>
                  <ContentsList data={item} />
                </Box>
              ))}
            </VStack>
          </AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
